import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Intro from "./sections/Intro";
import Join from "./sections/Join";
import Company from "./sections/Company";
import Request from "./sections/Request";
import Event from "./sections/Event";
import Partner from "./sections/Partner";
import Head from "../Base/Head";

export default function UNGA({ event }) {
  const [gradientReady, setGradientReady] = useState(false);
  const head = {
    title: "Social Innovation Summit @ UNGA 2026",
    description:
      "We’re excited to welcome you to Social Innovation Summit 2026 this June in Atlanta gathering 1,250+ bold thinkers and purpose-driven leaders, all committed to building what’s next. As part of your experience, we’re thrilled to extend an exclusive invitation to our VIP event series – a collection of intimate, themed lunches and dinners designed to spark real connection, candid conversation, and meaningful collaboration.",
    url: "https://sisvip.landmarkventures.com",
    image: "https://i.ibb.co/fzsNXTs2/sisvip-2026-twittercard.png",
  };

  return (
    <>
      <Head head={head} />
      <div
        className={`events-wrapper unga-wrapper sisvip-wrapper redesign ${
          gradientReady ? "gradient-ready" : ""
        }`}
      >
        <Intro event={event} />
        {/* <Join /> */}
        {/* <Event /> */}
        <Request event={event} onOptionsLoadedChange={setGradientReady} />
        {/* <Company /> */}
        {/* <Partner /> */}
      </div>
    </>
  );
}
